//  Internals
import { Select } from "antd";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import RCPagination from "rc-pagination";
import React, { useEffect, useState } from "react";
import { ENTITIES } from "../../constants/entities";

//  Manipulate the data
const { Option } = Select;
//  Component starts
const Pagination = ({
	columnKey,
	tableData,
	setCurrentPage,
	setCurrentLimit,
}) => {
	const [name, setName] = useState("items");
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [limit, setLimit] = useState(0);
	const [total, setTotal] = useState(0);
	useEffect(() => {
		setName(ENTITIES[columnKey]?.name);
	}, [columnKey]);

	useEffect(() => {
		if (tableData) {
			setTotal(tableData.total_items || 0);
			setLimit(tableData?.records?.length || 0);
			setPageSize(tableData?.items_per_page || 0);
			setPage(tableData.page || 1);
		}
	}, [tableData]);

	const numbers = [10, 20, 30, 40, 50];

	return (
		!isEmpty(numbers) && (
			<div className="table-footer d-flex align-items-center justify-content-between">
				<div>
					<label className="mr-2">Showing</label>
					<Select
						onChange={(number) => {
							setCurrentLimit && setCurrentLimit(number);
						}}
						value={limit}
					>
						{numbers.map((number) => (
							<Option value={number} key={number}>
								{number}
							</Option>
						))}
					</Select>
					<label className="ml-2">
						Out of {total} {name}
					</label>
				</div>
				<div className="pagination-list">
					<RCPagination
						className="ant-pagination"
						total={total} //  items total count
						current={page} //  current page
						pageSize={pageSize} //  items per page
						onChange={(number) => {
							setCurrentPage && setCurrentPage(number);
						}} //  page change callback
					/>
				</div>
			</div>
		)
	);
};

/******************************************************************************************
@Purpose    :   To validate the props
*******************************************************************************************/
PropTypes.propTypes = {
	columnKey: PropTypes.string.isRequired,
};

export default Pagination;
